import React, { Component } from 'react'
import { TryMap, DocDelivery } from '../index'
import { changeTipoFigura } from '../../libs/utils/GlobalFunc';

class CreateRouteR2D2 extends Component {

    RefreshModel = (RouteDoc) => {
        const { RefreshRouteDoc } = this.props
        RefreshRouteDoc(RouteDoc);
    }

    //#region ######### ONCHANGE FIELDS MODEL ############################################################
    OnchangeRouteName = (value) => {
        const { RouteDoc } = this.props
        RouteDoc.Name = value;
        this.RefreshModel(RouteDoc);
    }

    OnchangeRouteCode = (value) => {
        const { RouteDoc } = this.props
        RouteDoc.Code = value;
        this.RefreshModel(RouteDoc);
    }

    OnchangeRouteDescription = (value) => {
        const { RouteDoc } = this.props
        RouteDoc.Description = value;
        this.RefreshModel(RouteDoc);
    }

    OnchangeDriver = async (index) => {
        const { RouteDoc, Drivers } = this.props
        RouteDoc.IdVDRV = Drivers[index].CodigoFiguraTransporte;
        RouteDoc.NameDriver = Drivers[index].Name;
        RouteDoc.AuxIndexDriver = index;
        await this.RefreshModel(RouteDoc);
    }

    OnchangeVehicle = (value) => {
        const { RouteDoc } = this.props
        RouteDoc.IdVHCL = value;
        this.RefreshModel(RouteDoc);
    }

    OnchangeRouteStatus = () => {
        const { RouteDoc } = this.props
        RouteDoc.IsActive = !RouteDoc.IsActive;
        this.RefreshModel(RouteDoc);
    }

    ChangeOrderDateInit = (value) => {
        const { RouteDoc } = this.props
        RouteDoc.InitialDate = value;
        RouteDoc.FinalDate = value;
        this.RefreshModel(RouteDoc);
    }

    ChangeOrderDateFinal = (value) => {
        const { RouteDoc, } = this.props
        RouteDoc.FinalDate = value;
        this.RefreshModel(RouteDoc);


    }

    ValidateFinalDate = () => {
        const { RouteDoc, showAlert } = this.props
        if (RouteDoc.FinalDate < RouteDoc.InitialDate) {
            showAlert({ type: 'error', message: `LA FECHA FINAL NO PUEDE SER MENOR ` });
            RouteDoc.FinalDate = RouteDoc.InitialDate;
            this.RefreshModel(RouteDoc);
        }
    }


    //#endregion

    ValidateEditMode = (Funct) => {
        const { EditableMode, showAlert } = this.props
        if (!EditableMode) {
            showAlert({ type: 'info', message: `DEBES HABILITAR EL MODO EDICIÓN` });
            return
        }
        Funct();
    }

    render() {
        const {
            Waypoints,
            InitDateSearch,
            FinalDateSearch,
            UnAssignedDocs,
            ChangeInitialDate,
            ChangeFinalDate,
            GetDeliveryRoutesByDate,
            ActualDeliveries,
            GetInfoRouteById,
            RouteDoc,
            GetDeliveryRoutePoints,
            ChangeDateToSearch,
            dateToSearch,
            GetAllUnAssignedDocs,
            AddToRoute,
            DeleteDocFromDeliveryRouteDoc,
            ChangeEditableMode,
            EditableMode,
            DeleteDeliveryRoute,
            SaveUpdateDeliveryRoute,
            Vehicles,
            Drivers,

            //r2d2
            ActualRoutes,
            RefreshRouteDoc,
            GenerateRouteDocByIA


        } = this.props

        return (
            <div className='m-5'>
                <div id="create-Route-form" style={{ marginTop: "2vh" }}>
                    <div className="content-wrapper">
                        <div className="container-xxl flex-grow-1 container-p-y">
                            <div className='row'>
                                <div className="col-md-4 col-lg-4 order-0 mb-4">
                                    <div className="card h-100">
                                        <div className="card-header d-flex align-items-center justify-content-between">
                                            <div className='row'>
                                                <div className="col-md-6">
                                                    <h5 className="card-title m-0 me-2">Rutas por fecha R2D2</h5>
                                                </div>
                                                <div className="col-md-6">
                                                    <input id="orderFechaFinRelation"
                                                        className="form-control btn-outline-secondary listSerie " type="date"
                                                        placeholder="Fecha min" autoComplete="off"
                                                        value={dateToSearch ?? ''}
                                                        onChange={(event) => ChangeDateToSearch(event.target.value)}
                                                        onKeyPress={(ev) => {
                                                            if (ev.key === 'Enter') {
                                                                GetDeliveryRoutesByDate(dateToSearch);
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body scrollCardBP" >
                                            <ul className="p-0 m-0">
                                                {ActualDeliveries && ActualDeliveries.length > 0 &&
                                                    ActualDeliveries.map((delivery) => {
                                                        return (
                                                            <li className="d-flex mb-4 pb-1" onClick={() => {
                                                                GetDeliveryRoutePoints(delivery.IdORDL)
                                                                GetInfoRouteById(delivery.IdORDL)
                                                            }}>
                                                                <div className="avatar flex-shrink-0 mr-2 ml-2 mt-2" >
                                                                    <img style={{ width: '3.5vh' }} src={require('../../images/ico/deliveries.png')} alt="User" className="rounded" />
                                                                </div>
                                                                <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                                                                    <div className="me-2">
                                                                        <h6 className="mb-0">{delivery.DriverName ?? ""} Vehículo: {delivery.TipodeUnidad ?? ''}  Placa: {delivery.PlacaVM ?? ''}</h6>
                                                                        <small className="text-muted d-block mb-1">{delivery.Code ?? ""}</small>

                                                                    </div>
                                                                    <div className="user-progress d-flex align-items-center gap-1 mr-2">
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        )
                                                    })}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-8 mb-4 order-2">
                                    <div className="card">
                                        <div className="d-flex align-items-end row">
                                            <div className="col-sm-12">
                                                <div className="card-body" >
                                                    <div>
                                                        <DocDelivery
                                                            RouteDoc={RouteDoc}
                                                            ActualRoutes={ActualRoutes}
                                                            RefreshRouteDoc={RefreshRouteDoc}
                                                            Vehicles={Vehicles}
                                                            Drivers={Drivers}
                                                            GenerateRouteDocByIA={GenerateRouteDocByIA}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card">
                                        <div className="d-flex align-items-end row">
                                            <div className="col-sm-12">
                                                <div className="card-body" >
                                                    <div >
                                                        <TryMap
                                                            waypoints={Waypoints}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className="col-lg-8 mb-4 order-0">
                                    <div className="card">
                                        <div className="d-flex align-items-end row">
                                            <div className="col-sm-12">
                                                <div className="card-body">
                                                    <div className='row'>
                                                        <div className='col-md-8'>
                                                            <h5 className="card-title text-primary">Editar Ruta </h5>
                                                        </div>
                                                        <div className='col-md-4 text-right'>
                                                            <button
                                                                className="btn btn-sm"
                                                                type="button"
                                                                onClick={() => ChangeEditableMode()}
                                                            >
                                                                Editar <i className="fa fa-pencil-square-o"></i>
                                                            </button>
                                                        </div>


                                                    </div>



                                                    <div className='row'>
                                                        <div className='col-sm-6'>
                                                            <label for="exampleInputEmail1">Identificador nombre</label>
                                                            <input
                                                                disabled={EditableMode === true ? false : true}
                                                                type="email"
                                                                className="form-control"
                                                                id="exampleInputEmail1"
                                                                placeholder="Identificador nombre"
                                                                onChange={(event) => this.OnchangeRouteName(event.target.value)}


                                                                value={RouteDoc && RouteDoc.Name !== '' ? RouteDoc.Name : ''}

                                                            />
                                                        </div>
                                                        <div className='col-sm-6'>
                                                            <label for="exampleInputEmail1">Código del evento</label>
                                                            <input
                                                                disabled={EditableMode === true ? false : true}
                                                                type="email"
                                                                className="form-control"
                                                                id="exampleInputEmail1"
                                                                placeholder="Código del evento"
                                                                value={RouteDoc && RouteDoc.Code !== '' ? RouteDoc.Code : ''}
                                                                onChange={(event) => this.OnchangeRouteCode(event.target.value)}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='row'>
                                                        <div className='col-sm-6'>
                                                            <label for="exampleInputEmail1">Chofer</label>
                                                            {/* <input
                                                                disabled={EditableMode === true ? false : true}
                                                                type="email"
                                                                class="form-control"
                                                                id="exampleInputEmail1"
                                                                placeholder="Chofer"
                                                                value={RouteDoc && RouteDoc.NameDriver !== '' ? RouteDoc.NameDriver : ''}
                                                            /> */}
                                                            <select id="toggleCostumer"
                                                                className="form-control"
                                                                disabled={EditableMode === true ? false : true}
                                                                onChange={(event) => this.OnchangeDriver(event.target.value)}
                                                                value={RouteDoc ? RouteDoc.AuxIndexDriver : ''}
                                                            >
                                                                <option>Seleccione el chofer responsable</option>
                                                                {Drivers && Drivers.map((driver, index) => {
                                                                    return (
                                                                        <option key={index} value={index}>
                                                                            {driver?.NombreFigura ?? ""}.  -  {changeTipoFigura((driver?.TipoFigura ?? "").trim() ?? '')}
                                                                        </option>
                                                                    );
                                                                })}

                                                            </select>
                                                        </div>

                                                        <div className='col-sm-6'>
                                                            <label for="exampleInputEmail1">Vehículo</label>
                                                            {/* <input
                                                                // disabled={true}
                                                                disabled={EditableMode === true ? false : true}
                                                                type="email"
                                                                class="form-control"
                                                                id="exampleInputEmail1"
                                                                placeholder='Vehículo'
                                                                value={RouteDoc && RouteDoc.tipodeUnidad !== '' ? RouteDoc.tipodeUnidad : ''}
                                                            /> */}
                                                            <select id="toggleCostumer"
                                                                className="form-control"
                                                                disabled={EditableMode === true ? false : true}
                                                                onChange={(event) => this.OnchangeVehicle(event.target.value)}
                                                                value={RouteDoc && RouteDoc.IdVHCL !== '' ? RouteDoc.IdVHCL : ''}
                                                            >
                                                                <option>Seleccione el chofer responsable</option>
                                                                {Vehicles && Vehicles.map((vehicle, index) => {
                                                                    return (
                                                                        <option key={index} value={vehicle.CodigoAutotransporte}>
                                                                            {vehicle.TipodeUnidad} - {vehicle.ConfigVehicular}. Matricula: {vehicle.PlacaVM}
                                                                        </option>
                                                                    );
                                                                })}

                                                            </select>


                                                        </div>
                                                    </div>
                                                    <div className='row'>

                                                        <div className='col-sm-6'>
                                                            <div className='col-sm-6'>
                                                                <label for="exampleInputEmail1">Contacto chofer </label>
                                                                <input
                                                                    disabled={true}
                                                                    type="email"
                                                                    className="form-control"
                                                                    id="exampleInputEmail1"
                                                                    placeholder='Contacto chofer'

                                                                    value={RouteDoc && RouteDoc.email !== '' ? RouteDoc.email : ''}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className='col-sm-6'>
                                                            <label for="exampleInputEmail1">Vehículo placa </label>
                                                            <input
                                                                disabled={true}
                                                                type="email"
                                                                className="form-control"
                                                                id="exampleInputEmail1"
                                                                placeholder='Vehículo placa'
                                                                value={RouteDoc && RouteDoc.vehiclePlate !== '' ? RouteDoc.vehiclePlate : ''}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='row'>
                                                        <div className='col-sm-6'>
                                                            <label for="exampleInputEmail1"><strong>Comentario</strong></label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Comentario"
                                                                disabled={EditableMode === true ? false : true}
                                                                value={RouteDoc.Description ? RouteDoc.Description : ''}
                                                                onChange={(event) => this.OnchangeRouteDescription(event.target.value)}
                                                            />


                                                        </div>
                                                        <div className='col-sm-6'>
                                                            <label for="exampleInputEmail1"><strong>Activa</strong></label>
                                                            <div className="form-switch" style={{ position: "relative", display: "block", paddingLeft: "2.5rem" }}>
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    checked={RouteDoc.IsActive}
                                                                    disabled={EditableMode === true ? false : true}
                                                                    onClick={() => this.OnchangeRouteStatus()}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='row'>
                                                        <div className='col-sm-6'>
                                                            <h4 className="pr-2">Fecha de entrega: </h4>
                                                            <input
                                                                disabled={EditableMode === true ? false : true}
                                                                id="fechaInicio"
                                                                type="date"
                                                                className="form-control col-md-6"
                                                                onChange={(event) => this.ChangeOrderDateInit(event.target.value)}
                                                                value={RouteDoc && RouteDoc.InitialDate !== '' ? RouteDoc.InitialDate : ''}

                                                            />

                                                        </div>
                                                        <div className='col-sm-6'>
                                                            {/* <h4 className="pr-2">Final: </h4>
                                                            <input
                                                                disabled={EditableMode === true ? false : true}
                                                                id="fechaInicio"
                                                                type="date"
                                                                className="form-control col-md-6"
                                                                onChange={(event) => this.ChangeOrderDateFinal(event.target.value)}
                                                                value={RouteDoc && RouteDoc.FinalDate !== '' ? RouteDoc.FinalDate : ''}
                                                            /> */}
                                                        </div>
                                                    </div>
                                                    <h5 className="card-title text-primary mt-4 mb-2">Documentos dentro de la ruta  </h5>
                                                    <div className='row'>
                                                        <div className='col-sm-12'>
                                                            <div className="scrollAddesdBP">
                                                                <ul className="p-0 m-0">
                                                                    {RouteDoc && RouteDoc.DocsLines.length > 0 &&
                                                                        RouteDoc.DocsLines.map((docLine, index) => {
                                                                            return (
                                                                                <li className="d-flex mb-4 pb-1">
                                                                                    <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                                                                                        <div className="me-2">
                                                                                            <small className="text-muted d-block mb-1">{`Latitud: ${docLine.U_FMB_GPSLatS}  Longitud: ${docLine.U_FMB_GPSLonS}`}</small>
                                                                                            <h6 className="mb-0">DocNum: {docLine.DocNum} Cliente: {docLine.CardCode}</h6>
                                                                                        </div>
                                                                                        <div className="user-progress d-flex align-items-center gap-1">
                                                                                            <button
                                                                                                className="btn btn-sm"
                                                                                                type="button"
                                                                                                onClick={() => this.ValidateEditMode(() => DeleteDocFromDeliveryRouteDoc(index))}
                                                                                            >
                                                                                                <i className="fa fa-trash-o"></i>
                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                </li>
                                                                            );
                                                                        })

                                                                    }
                                                                </ul>

                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div className="row mt-2 ">
                                                        <div className='col-md-6'>

                                                        </div>

                                                        <div className='col-md-6 text-right'>
                                                            {EditableMode && EditableMode === true &&

                                                                <>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-warning mr-2"

                                                                        onClick={() => SaveUpdateDeliveryRoute()}
                                                                    >Guardar cambios</button>

                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-danger"

                                                                        onClick={() => DeleteDeliveryRoute()}
                                                                    >Eliminar ruta</button>


                                                                </>

                                                            }
                                                        </div>


                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4 order-2 mb-4">
                                    <div className="card h-100">
                                        <div className="card-header d-flex align-items-center justify-content-between">
                                            <h5 className="card-title m-0 me-2">Agregar documento</h5>
                                        </div>
                                        <div className="card-body " >
                                            <div className='row'>
                                                <div className="form-group col">
                                                    <label className="Desde"><strong>Desde:&nbsp;&nbsp;</strong></label>
                                                    <input id="orderFechaInicioRelation"
                                                        className="form-control btn-outline-secondary listSerie" type="date"
                                                        placeholder="Fecha inicio" autoComplete="off"
                                                        value={InitDateSearch ?? ''}
                                                        onChange={(event) => ChangeInitialDate(event.target.value)}
                                                        onKeyPress={(ev) => {
                                                            if (ev.key === 'Enter') {
                                                                GetAllUnAssignedDocs();

                                                            }
                                                        }}

                                                    />
                                                </div>
                                                <div className="form-group col">
                                                    <label className="Hasta"><strong> &nbsp;&nbsp;Hasta:&nbsp;&nbsp;</strong></label>
                                                    <input id="orderFechaFinRelation"
                                                        className="form-control btn-outline-secondary listSerie " type="date"
                                                        placeholder="Fecha min" autoComplete="off"
                                                        value={FinalDateSearch ?? ''}
                                                        onChange={(event) => ChangeFinalDate(event.target.value)}
                                                        onKeyPress={(ev) => {
                                                            if (ev.key === 'Enter') {
                                                                GetAllUnAssignedDocs();
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                                                <ul className="p-0 m-0">
                                                    <li className="d-flex mb-4 pb-1">
                                                        <div className="avatar flex-shrink-0 mr-2 ml-2 mt-2" style={{ maxHeight: "25px", maxWidth: "25px" }}>

                                                        </div>
                                                    </li>
                                                    {UnAssignedDocs && UnAssignedDocs.length > 0 &&
                                                        UnAssignedDocs.map((order, index) => {
                                                            return (
                                                                <li className="d-flex mb-4 pb-1 row">
                                                                    <div className="d-flex mt-2 col-md-1">
                                                                        <button className="btn btn-sm" type="button">
                                                                            <i className="fa fa-info-circle"></i>
                                                                        </button>
                                                                    </div>
                                                                    <div className="d-flex col-md-11">
                                                                        <div className='row'>
                                                                            <div className="me-2 col-md-10">
                                                                                <small className="text-muted d-block mb-1">DocNum:{order.DocNum}</small>
                                                                                <h6 className="mb-0">Cliente: {order.CardName}. CardCode: {order.CardCode}  </h6>
                                                                            </div>
                                                                            <button className="btn btn-sm col-md-2" type="button" onClick={() => this.ValidateEditMode(() => AddToRoute(order))} >
                                                                                <i className="fa fa-plus"></i>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            );
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="content-backdrop fade"></div>
                    </div>
                </div>


            </div>
        )
    }
}

export default CreateRouteR2D2